import { createSlotRecipe } from './runtime';

const siteSidebarConfig = {"name":"siteSidebar","slots":["positioner","panel","header","list","item","icon","label","indicator","sub","subItem","footer"]}

export const siteSidebar = /* @__PURE__ */ createSlotRecipe(siteSidebarConfig)